export default {
	data(){
		return {
			tableGBoptions: { 
				options: { anular: 'Anular Afiliación'},
				modals: [
					{
						modal: "Registrar",
						icon: "credit-card",
						title: "Registro de la afiliación",
						show: "info_ingresos/id"
					  },
				]
			},

			tableGBSearch: ['datos_afiliado/documento','datos_afiliado/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento', sort: null, sortTable: 'datos_afiliado/documento'},
					tbody: { td: ['datos_afiliado/documento',]}
				},
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Asesor', },
					tbody: { td: ['datos_asesor/name'],}
				},
				{
					thead: { th: 'Fecha', },
					tbody: { td: ['info_aportes/fecha'],}
				},
				{
					thead: { th: 'Servicios', },
					tbody: { table: {
						value: false,
							tabla: 'aportes_registro/servicios',
							search: ['name'],						
							items: [
								{
									thead: { th: 'Servicio'},
									tbody: {td: ['name']},
								},	
								{
									thead: { th: 'Entidad'},
									tbody: {td: ['id_list']},
								},
								{
									thead: { th: 'Valor'},
									tbody: {td: ['valor']},
								},							
							]
						}
					}
				},
				{
					thead: { th: 'Periodo', },
					tbody: { td: ['list_mes/name','list_ano/name']}
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'],}
				},
				{
					thead: { th: 'Registro'},
					tbody: {td: ['info_aportes/id'], link: '/api/pdf/registroaportes'},
				},
			],			
		
		}
	},
}